export default __webpack_public_path__ + "static/media/facebook.4ea7a083.png";